<template>
  <Can action="store-campaign" subject="thread">
    <div data-component-group="threads-dialog" data-component="add-campaign">
      <dialog-add
        :title="$t('submit_new_campaign')"
        icon="content_cut"
        is-fullscreen
        :is-on="true"
        :on-close="onDialogClose"
      >
        <template v-slot:content>
          <forms-threads-add-campaign
            class="elevation-1"
            :is-loading="isAddingCampaign"
            :on-cancel="onCancel"
            :on-submit="createCampaign"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  const { confirm } = window;

  export default {
    data() {
      return {
        isAddingCampaign: false,
      };
    },
    computed: {
      isDirtyCampaign() {
        return this.$store.getters['threads/isDirtyCampaign'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'threads' });
      },
      onDialogClose() {
        if (!this.isDirtyCampaign) {
          return this.closeDialog();
        }

        if (confirm(this.$t('are_you_sure_you_want_to_leave_this_page'))) {
          this.closeDialog();
        }
      },
      closeDialog() {
        this.onCancel();
        return this.$store.dispatch('threads/setDirtyCampaign', false);
      },
      createCampaign(query) {
        this.isAddingCampaign = true;

        return this.$store
          .dispatch('threads/createCampaign', query)
          .then((res) => {
            this.getLimits();
            this.$router.push({ name: 'threads', query: { status: 'success' } });
            return res;
          })
          .catch((error) => error)
          .finally(() => {
            this.isAddingCampaign = false;
          });
      },
      getLimits() {
        if (this.$ability.can('view-widget', 'limits')) {
          return this.$store.dispatch('businessUsers/getLimits');
        }
        return [];
      },
    },
  };
</script>
